import { createUseStyles } from 'react-jss'
import { forDesktopDown } from 'src/config/mediaQueries'
import { isOnlineTerminPage } from 'src/utils/url'
import customColors from 'src/config/colorsV2'

export default createUseStyles({
  root: {
    display: 'grid',
    height: 'calc(100vh - 79px)',
    gridTemplateAreas: `
      "header"
      "body"
      "footer"
    `,
    gridTemplateRows: 'auto 1fr auto',

    [forDesktopDown]: {
      height: isOnlineTerminPage ? 'calc(100vh - 72px)' : '100vh',
    },
  },
  header: {
    zIndex: 10,
    gridArea: 'header',
    position: 'sticky',
    top: 0,
  },
  body: {
    gridArea: 'body',
    overflow: 'auto',
    background: customColors.background,
  },
  bodyFlexGrow: {
    flexGrow: 1,
  },
  mobilePageWithTopPadding: {
    [forDesktopDown]: {
      paddingTop: '24px',
    },
  },
  footer: {
    bottom: 0,
    zIndex: 10,
    gridArea: 'footer',
    position: 'sticky',
  },
  modal: {
    height: '100%',
  },
  withSidebarContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  withSidebarBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
})
